import React from 'react';
import { CreditCardNetwork } from '@wix/cashier-common/dist/src/enums/payments/CreditCardNetwork';
import cn from 'classnames';
import { Expiration } from '../../../types/Expiration';
import { Theme } from '../../../types/Theme';
import { DH } from '../../../utils/DataHook';
import * as s from './styles.scss';
import * as methodItemStyles from '../../CustomPaymentMethodList/PaymentMethodItem/styles.scss';
import { formatMonth, formatYear } from './helpers';
import { t } from '../../../utils/i18n';
import { CreditCardNetworkIcon } from '../../PaymentMethodIcon/icons/CreditCardNetworkIcon';

export interface SavedCreditCardItemProps {
  theme?: Theme;
  isSelected: boolean;
  isExpired: boolean;
  lastFourDigits: string;
  expiration: Expiration;
  network: CreditCardNetwork;
  cardId: string;

  onClick(): void;
}

export const SavedCreditCardItem: React.FunctionComponent<SavedCreditCardItemProps> =
  (props) => {
    const {
      theme,
      isSelected,
      isExpired,
      cardId,
      network,
      lastFourDigits,
      expiration,

      onClick,
    } = props;

    const handleClick = (e) => {
      e.stopPropagation();
      e.preventDefault();

      onClick();
    };

    return (
      <label
        className={cn({
          [methodItemStyles.paymentMethod]: true,
          [methodItemStyles.modalTheme]: theme === Theme.modal,
        })}
        data-hook={DH.SavedCard.Item.Container}
        htmlFor={cardId}
        onClick={handleClick}
      >
        <div className={methodItemStyles.radioContainer} role="menuitem">
          <input
            className={methodItemStyles.paymentMethodInput}
            type="radio"
            id={cardId}
            value={cardId}
            name="creditCardSelection"
            checked={isSelected}
            tabIndex={-1}
            onChange={() => {
              // fix React error with checked prop without onChange handler
            }}
            aria-describedby={`wcn-cc-description-${cardId}`}
            data-hook={DH.SavedCard.Item.Radio(cardId)}
          />
          <i role="radio" aria-checked={isSelected ? 'true' : 'false'} />
          <div>
            <div
              className={cn(
                methodItemStyles.cardNetwork,
                s.cardNetworkContainer
              )}
            >
              <span className={s.cardNetwork}>{t(`network.${network}`)}</span>
              <span className={s.cardLastDigits}>
                (
                <span data-hook={DH.SavedCard.Item.LastDigits}>
                  {lastFourDigits}
                </span>
                )
              </span>
            </div>
            {isExpired ? (
              <div
                className={methodItemStyles.red}
                data-hook={DH.SavedCard.Item.ExpiredMessage}
              >
                {t('savedCreditCards.expired')}
              </div>
            ) : (
              <div className={s.expiredContainer}>
                <span className={s.expiredDateLabel}>
                  {t('savedCreditCards.expireDate')}
                </span>
                <span data-hook={DH.SavedCard.Item.ExpireDate}>
                  <span className={s.expiredDateMonth}>
                    {formatMonth(expiration.month)}
                  </span>
                  <span>/</span>
                  <span>{formatYear(expiration.year)}</span>
                </span>
              </div>
            )}
          </div>
        </div>
        <div className={methodItemStyles.icon}>
          <CreditCardNetworkIcon cardNetwork={network} />
        </div>
      </label>
    );
  };
SavedCreditCardItem.displayName = 'SavedCreditCardItem';
